import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import { DataGrid } from '@mui/x-data-grid';
import useStyles from './styles';
// import { PortfoliosMenu } from './PortfoliosMenu';
import { useStore } from 'src/stores';
import { PROPERTY_STATUS_ENUM } from 'src/constants/property';
import { currencyFormatter } from 'src/utils/translator';
import { isValueNumber } from 'src/utils/typeValidators';
import moment from 'moment';
import NoDataPlaceholder from 'src/components/shared/NoDataPlaceholder';
import { PropertyActionsMenu } from 'src/components/shared/PropertyActionsMenu';
import { Button } from '@mui/material';
export const PortfoliosList = observer(_ref => {
  var _portfolio$properties;
  let portfolioDetailsSearchKey = _ref.portfolioDetailsSearchKey,
    selectProperty = _ref.selectProperty,
    openPropertyDetails = _ref.openPropertyDetails,
    handleTabToBillingChange = _ref.handleTabToBillingChange,
    handleShowEnrollModal = _ref.handleShowEnrollModal,
    handleOpenAssignPortfoliosToPropertyModal = _ref.handleOpenAssignPortfoliosToPropertyModal,
    selectActionCallback = _ref.selectActionCallback,
    handleRemovePortfolioFromProperty = _ref.handleRemovePortfolioFromProperty;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const portfolio = store.homeDashboardStore.getCurrentPortfolio;
  const properties = portfolio === null || portfolio === void 0 || (_portfolio$properties = portfolio.properties) === null || _portfolio$properties === void 0 ? void 0 : _portfolio$properties.filter(i => {
    const searchPhrase = new RegExp(portfolioDetailsSearchKey, 'gi');
    return portfolioDetailsSearchKey.length > 0 ? " ".concat(i.dashboard.propertyAddress).search(searchPhrase) > 0 : true;
  });
  const Cell = _ref2 => {
    let value = _ref2.value,
      _ref2$isProperty = _ref2.isProperty,
      isProperty = _ref2$isProperty === void 0 ? false : _ref2$isProperty,
      _ref2$propertyStatus = _ref2.propertyStatus,
      propertyStatus = _ref2$propertyStatus === void 0 ? '' : _ref2$propertyStatus,
      rowData = _ref2.rowData;
    return /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: value,
      placement: "top"
    }, !isProperty && /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.cellContent, " ").concat(!isValueNumber(value) ? 'disabled' : '')
    }, !isValueNumber(value) ? 'N/A' : value), isProperty && /*#__PURE__*/React.createElement("div", {
      className: classes.propertyCell,
      onClick: event => {
        event.stopPropagation();
        event.preventDefault();
        selectProperty(rowData.id);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.propertyCellIcon
    }, /*#__PURE__*/React.createElement("i", {
      className: "".concat(classes.propertyCellStatus, " ").concat(propertyStatus === PROPERTY_STATUS_ENUM.Active ? 'success' : propertyStatus === PROPERTY_STATUS_ENUM.Inactive ? 'warning' : 'error')
    }), /*#__PURE__*/React.createElement(Icon, {
      type: "building"
    })), /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.cellContent, " ").concat(!value ? 'disabled' : '')
    }, !value ? 'N/A' : value)));
  };
  const indicators = /*#__PURE__*/React.createElement("span", {
    className: "indicators"
  }, /*#__PURE__*/React.createElement("span", {
    className: "inline-arrow"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  })), /*#__PURE__*/React.createElement("span", {
    className: "inline-filter"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "equalizer"
  })));
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign ? classes.rightAlign : ''
  }, text, indicators);
  let columns = [{
    field: 'property',
    align: 'left',
    flex: 1,
    minWidth: 220,
    maxWidth: 1000,
    valueGetter: params => params.row.dashboard.propertyAddress,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      rowData: params.row,
      value: params.row.dashboard.propertyAddress,
      propertyStatus: params.row.dashboard.propertyStatus,
      isProperty: true
    }),
    renderHeader: () => renderHeader(t('dashboard_page.property'))
  }, {
    field: 'total',
    align: 'right',
    width: 70,
    valueGetter: params => params.row.dashboard.unitsTotal,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.dashboard.unitsTotal
    }),
    renderHeader: () => renderHeader(t('Total units'), true)
  }, {
    field: 'enrolled',
    align: 'right',
    width: 90,
    valueGetter: params => params.row.dashboard.unitsEnrolled,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.dashboard.unitsEnrolled
    }),
    renderHeader: () => renderHeader(t('Enrolled units'), true)
  }, {
    field: 'utilities',
    align: 'right',
    width: 80,
    valueGetter: params => params.row.dashboard.utilityCount,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: params.row.dashboard.utilityCount
    }),
    renderHeader: () => renderHeader(t('Utilities'), true)
  }, {
    field: 'accountReceivable',
    align: 'right',
    width: 90,
    valueGetter: params => params.row.dashboard.accountsReceivable,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: !!params.row.dashboard.accountsReceivable ? currencyFormatter(Number(params.row.dashboard.accountsReceivable)) : 'N/A'
    }),
    renderHeader: () => renderHeader(t('Account receivable'), true)
  }, {
    field: 'payoutToDate',
    align: 'right',
    width: 90,
    valueGetter: params => params.row.dashboard.distributionToDate,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: !!params.row.dashboard.distributionToDate ? currencyFormatter(Number(params.row.dashboard.distributionToDate)) : 'N/A'
    }),
    renderHeader: () => renderHeader(t('portfolios_properties_page.properties_data_grid_reimbursement_for', {
      monthName: 'to date'
    }), true)
  }, {
    field: 'payoutToLastMonth',
    align: 'right',
    width: 120,
    valueGetter: params => params.row.dashboard.distributionForCurrentMonth,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: !!params.row.dashboard.distributionForCurrentMonth ? currencyFormatter(Number(params.row.dashboard.distributionForCurrentMonth)) : 'N/A'
    }),
    renderHeader: () => renderHeader(t('portfolios_properties_page.properties_data_grid_reimbursement_for', {
      monthName: moment().format('MMMM YY')
    }), true)
  }, {
    field: 'payoutToUpcomingMonth',
    align: 'right',
    width: 120,
    valueGetter: params => params.row.dashboard.distributionForNextMonth,
    renderCell: params => /*#__PURE__*/React.createElement(Cell, {
      value: !!params.row.dashboard.distributionForNextMonth ? currencyFormatter(Number(params.row.dashboard.distributionForNextMonth)) : 'N/A'
    }),
    renderHeader: () => renderHeader(t('portfolios_properties_page.properties_data_grid_reimbursement_for', {
      monthName: moment().add(1, 'month').format('MMMM YY')
    }), true)
  },
  // NOTE: hide autoBilling for now
  // {
  //   field: 'autoBilling',
  //   align: 'left',
  //   width: 120,
  //   valueGetter: params => params.row.autoBilling,
  //   renderCell: params => <Cell value={params.row.autoBilling} isAutoBilling />,
  //   renderHeader: () => renderHeader(t('Auto-billing')),
  // },
  {
    field: 'actions',
    align: 'left',
    width: 63,
    // renderCell: () => <PortfoliosMenu />,
    renderCell: params => {
      var _params$row, _params$row2, _params$row3, _params$row4, _params$row7;
      return /*#__PURE__*/React.createElement(PropertyActionsMenu, {
        id: params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.id,
        portfolioId: params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 || (_params$row2 = _params$row2.propertyPortfolioInfo) === null || _params$row2 === void 0 ? void 0 : _params$row2.id,
        isActive: (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.propertyStatus) === PROPERTY_STATUS_ENUM.Active,
        isInDefaultPortfolio: (_params$row4 = params.row) === null || _params$row4 === void 0 || (_params$row4 = _params$row4.propertyPortfolioInfo) === null || _params$row4 === void 0 ? void 0 : _params$row4.isDefault,
        handleShowEnrollModal: () => {
          var _params$row5, _params$row6;
          handleShowEnrollModal(true, {
            portfolioId: params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 || (_params$row5 = _params$row5.propertyPortfolioInfo) === null || _params$row5 === void 0 ? void 0 : _params$row5.id,
            propertyId: params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.id,
            enablePortfolioSelect: false,
            enablePropertySelect: false
          });
        },
        name: params === null || params === void 0 || (_params$row7 = params.row) === null || _params$row7 === void 0 || (_params$row7 = _params$row7.dashboard) === null || _params$row7 === void 0 ? void 0 : _params$row7.propertyAddress,
        selectActionCallback: selectActionCallback,
        openPropertyDetails: openPropertyDetails,
        changeActiveProperty: () => {
          if (selectActionCallback) {
            var _params$row8, _params$row9;
            selectActionCallback({
              entityType: 'portfolio',
              _id: params === null || params === void 0 || (_params$row8 = params.row) === null || _params$row8 === void 0 || (_params$row8 = _params$row8.propertyPortfolioInfo) === null || _params$row8 === void 0 ? void 0 : _params$row8.id,
              prefetchDataOnly: false
            });
            selectActionCallback({
              entityType: 'property',
              _id: params === null || params === void 0 || (_params$row9 = params.row) === null || _params$row9 === void 0 ? void 0 : _params$row9.id,
              prefetchDataOnly: false
            });
          }
          if (handleTabToBillingChange) handleTabToBillingChange();
        },
        handleOpenAssignPortfoliosToPropertyModal: () => handleOpenAssignPortfoliosToPropertyModal({
          property: params === null || params === void 0 ? void 0 : params.row
        }),
        handleRemovePortfolioFromProperty: () => {
          var _params$row0;
          return handleRemovePortfolioFromProperty({
            payload: params === null || params === void 0 ? void 0 : params.row,
            portfolioId: params === null || params === void 0 || (_params$row0 = params.row) === null || _params$row0 === void 0 || (_params$row0 = _params$row0.propertyPortfolioInfo) === null || _params$row0 === void 0 ? void 0 : _params$row0.id
          });
        },
        menuTriggerExternal: /*#__PURE__*/React.createElement(Button, {
          variant: "actionIcon",
          size: "small"
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "dotdotdot"
        }))
      });
    },
    renderHeader: () => renderHeader(t(''))
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(DataGrid, {
    rows: store.portfolios.getPortfoliosDashboardAsync.inProgress ? [] : properties,
    rowHeight: 52,
    columns: columns,
    columnHeaderHeight: 60,
    getRowId: row => {
      var _row$propertyPortfoli;
      return "".concat(row === null || row === void 0 ? void 0 : row.id, "-").concat(row === null || row === void 0 || (_row$propertyPortfoli = row.propertyPortfolioInfo) === null || _row$propertyPortfoli === void 0 ? void 0 : _row$propertyPortfoli.id);
    },
    disableRowSelectionOnClick: true,
    loading: store.portfolios.getPortfoliosDashboardAsync.inProgress,
    localeText: {
      noRowsLabel: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NoDataPlaceholder, {
        text: "No matching data found \uD83D\uDE2D\n Please adjust your filter settings!"
      }))
    }
  }));
});